<template>
  <div class="partners-slider">
    <Swiper
      v-bind="sliderParams"
    >
      <SwiperSlide v-for="i in 20">
        <div class="partners-slider-item">
          <img
            src="/local/templates/main/img/partners/partners-icon.png"
            alt="partners-icon"
            class="partners-slider-item__image"
          >
        </div>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script>
import {ref, reactive} from "vue";
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css';

export default {
  name: 'PartnersSlider',
  props: ['result'],
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const sliderParams = reactive({
      breakpoints: {
        320: {
          slidesPerView: 3.2,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 6,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 10,
          spaceBetween: 14,
        },
      },
    });

    return {
      sliderParams,
    }
  }
}
</script>

<style lang="scss" scoped>
.partners-slider {
  margin: 0 auto 100px;
  max-width: 1397px;
  padding-left: 15px;
  padding-right: 15px;
  @include tablet{
    margin-bottom: 81px;
  }
  @include mobile{
    margin-bottom: 71px;
    padding-right: 0;
  }
}
.partners-slider-item{
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  border: 1px solid #E9EBED;
  border-radius: 6px;
  padding: 30px;
  margin-bottom: 1px;
  transition: .2s linear border-color;
  @include mobile{
    padding: 20px;
  }
  &:hover{
    border-color: #A4AADA;
  }
  &__image{
    display: block;
  }
}
</style>